
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Space({workspace, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{workspace?.lib}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (workspace?.etat === 1) ? 'badge-warning' :
                        (workspace?.etat === 2) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {workspace?.etatdef}
                </div>
            </td>
            <td>{workspace?.datecrea ? <ReactTimeAgo date={Date.parse(workspace?.datecrea)} timeStyle="facebook" /> : ""}</td>
            <td className="text-center">
                <Link to={`/workspace/${workspace?.code}`} data-toggle="tooltip" title="consulter le droit" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}